import css from './style.module.scss';
import Deck from '../Deck';
import ProductCard from '../ProductCard';
import Wrap from '../Wrap';

export default function RelatedProducts ({ products }) {
	if (products.length === 0)
		return null;

	return (
		<section className={css.related}>
			<Wrap>
				<h2>You might also like...</h2>
			</Wrap>

			<Deck scroll>
				{products.map(product => <ProductCard {...product} />)}
			</Deck>
		</section>
	);
}
